module.exports = __webpack_public_path__ + "img/2.8fd4b8b4.png";